// src/utils/http/makeToasterErrorHandler.ts
import { normalizeHttpError } from "./normalizeHttpError";

/**
 * Cria um handler que normaliza o erro e chama autoError(msg) para cada mensagem.
 * Use dentro do componente, passando o autoError do seu usePageToast.
 */
export function makeToasterErrorHandler(autoError: (msg: string) => void) {
  return (err: unknown) => {
    const msgs = normalizeHttpError(err);
    msgs.forEach((m) => autoError(m));
  };
}
